import React, { PropsWithChildren, useEffect, useState } from 'react';

import IImageProcessorContext from 'app/providers/ImageProcessorProvider/context';
import imageProcessing from 'app/native/node-addons/imageProcessing';
import { IImageProcessor, ProcessingOptions } from 'app/interfaces/IImageProcessor';
import { DataImage } from 'app/interfaces/DataImage';

type ImageProcessingModuleDataImage = {
  data: Uint16Array;
  width: number;
  height: number;
  bytes_per_pixel: number;
  maxPixelValue: number;
  minPixelValue: number;
  windowCenter: number;
  windowWidth: number;
  collimation_rect: [number, number, number, number];
};

const makeImageProcessorFromImageProcessingModule = () => {
  if (!imageProcessing()) return undefined;

  const imageProcessor: IImageProcessor = {
    process: async (rawImage: DataImage, options: ProcessingOptions) => {
      const processedImage = await imageProcessing().processImage(rawImage, options);

      if (!processedImage) return undefined;

      const {
        data,
        width,
        height,
        bytes_per_pixel,
        maxPixelValue,
        minPixelValue,
        windowCenter,
        windowWidth,
        collimation_rect,
      } = processedImage;

      return {
        data,
        width,
        height,
        bytes_per_pixel,
        maxPixelValue,
        minPixelValue,
        windowCenter,
        windowWidth,
        collimation_rect,
      };
    },
  };
  return imageProcessor;
};

export default function ImageProcessorProvider({ children }: PropsWithChildren<{}>) {
  const [imageProcessor] = useState<IImageProcessor>(makeImageProcessorFromImageProcessingModule);

  return (
    <IImageProcessorContext.Provider value={imageProcessor}>
      {children}
    </IImageProcessorContext.Provider>
  );
}
